<template>
	<div>
		<label>表号</label>
		<a-input style="width:15rem; margin: 0 0.625rem;" v-model="sns"/>
		<a-button type="primary" icon="search" @click="queryTrace">查询</a-button>
		<a-table class="trace" size="small" :columns="columns" :data-source="list" :loading="loading"
					   rowKey="list.id" :pagination="{hideOnSinglePage:true}" :scoll="{y:500}">
					<span slot="createtimeSlot"  slot-scope="text, record">
						{{getFormatter(record.create_time)}}
					</span>
		</a-table>
	</div>
</template>

<script>
	const columns = [
		{ title: '表号',dataIndex: 'sn',width:180},
		{ title: '钢印号', dataIndex: 'steelnum',width:80},
		{ title: '产品型号', dataIndex: 'type',width:100},
		{ title: '规格', dataIndex: 'norm',width:145},
		{ title: '精度', dataIndex: 'precision',width:145},
		{ title: '量程比', dataIndex: 'range',width:100},
		{ title: '协议', dataIndex: 'protocal',width:100},
		{ title: '接口', dataIndex: 'wire',width:100},
		{ title: '检测设备', dataIndex: 'batchid',width:100},
		{ title: '水温', dataIndex: 'device',width:100},
		{ title: '水压', dataIndex: 'waterpressure',width:100},
		{ title: 'Q3',dataIndex: 'q3',width:100},
		{ title: 'Q2',dataIndex: 'q2',width:100},
		{ title: 'Q1',dataIndex: 'q1',width:100},
		{ title: '耐压等级',dataIndex: 'pressure',width:100},
		{ title: '外观',dataIndex: 'surface',width:100},
		{ title: '检测结果',dataIndex: 'result',width:100},
		{ title: '包装箱',dataIndex: 'boxsn',width:100},
		{ title: '打包日期',dataIndex: 'boxAt',width:100},
	];
	export default{
		props:[
			'sn',
		],
		data(){
			return {
				columns,
				list:[],
				loading:true,
				sns:this.sn
			}
		},
		methods:{
			queryTrace:function(){
				let url = 'http://121.196.104.130:8300/queryTrace'
				let param = {sn:this.sns};
				this.Api.fetchPost(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					 if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getFormatter:function(dateTime){
				let date = new Date(dateTime);
				return this.Config.formatDate(date);
			}
		},
		mounted() {
			this.queryTrace();
		}
	}
</script>
import 'element-ui/lib/theme-chalk/display.css';
<style>
	body {
		position: relative;
	}
	.trace {
		margin-top: 7px;
		overflow: auto;
	}
	 @media (max-width: 500px) {
		 body {
		     left: -1015px;
		 }
        .trace {
			position: absolute;
			left: 1111px;
		}	
		.ant-input {
			position: relative;
		    left: 1050px;
		}
		.ant-btn {
		    position: absolute;
		    left: 1046px;
		}
	 }
</style>
